import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './template.html';
import logger from '../../../shared/logger';
import './style.scss';
import { INCLUDED, CURRENTLY_NOT, EXCLUDED } from './../../../constants/tagAdditionalText';

export const INSIGHT_TAB = 'INSIGHT_TAB';

export class InsightComponent {
    static talentScoreData = [];
    static candidatesList = [];

    /* @ngInject */
    constructor(
        $scope,
        $state,
        PositionService,
        dynamicDataService,
        $timeout,
        RecruiterService,
        $filter,
        PositionReportService,
        NotificationService,
        clipboard,
        EnvSettings,
        RouteService,
        TalentScoreService,
        TalentService,
        InsightService,
        $stateParams,
        ModalDialogService,
        $uibModal,
        TFTTagsService,
    ) {
        const insightCtrl = this;
        this.$state = $state;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.PositionReportService = PositionReportService;
        this.ModalDialogService = ModalDialogService;
        this.$uibModal = $uibModal;
        this.tftTagsService = TFTTagsService;

        insightCtrl.getPotentialCandidates =  () => {
            return TalentScoreService.postTalentScore(insightCtrl.positionData.desiredCandidateProfile)
                .then((talentScoreResponse) => {
                    InsightComponent.talentScoreData = talentScoreResponse.result.resultList;
                    if (insightCtrl.insightBlocks &&
                        insightCtrl.insightBlocks.potentialCandidates) {
                        for (let i = 0; i < insightCtrl.insightBlocks.potentialCandidates.length; i++) {
                            const potentialCandidate = insightCtrl.insightBlocks.potentialCandidates[i];
                            const idx = _.findIndex(
                                InsightComponent.talentScoreData,
                                { talentID: potentialCandidate.talentId },
                            );
                            if (idx > -1) {
                                InsightComponent.talentScoreData.splice(idx, 1);
                            }
                        }
                    }
                    const talentIds = _.map(InsightComponent.talentScoreData, 'talentID');
                    if (talentIds.length > 0) {
                        TalentService.postTalents({ talentIDs: talentIds })
                            .then((talentsResponse) => {
                                if (insightCtrl.insightBlocks &&
                                    insightCtrl.insightBlocks.potentialCandidates) {
                                    for (let i = 0; i < insightCtrl.insightBlocks.potentialCandidates.length; i++) {
                                        const potentialCandidate = insightCtrl.insightBlocks.potentialCandidates[i];
                                        const idx = _.findIndex(
                                            talentsResponse.result,
                                            { talentId: potentialCandidate.talentId },
                                        );
                                        if (idx > -1) {
                                            talentsResponse.result.splice(idx, 1);
                                        }
                                    }
                                    InsightComponent.candidatesList = talentsResponse.result;
                                }
                                $scope.tabDisplay = 8;
                            })
                            .catch(err => logger.error(err));
                    }
                })
                .catch(err => logger.error(err));
        };

        insightCtrl.$onInit = async () => {
            insightCtrl.currentCandidatesListIndex = 0;
            const needLoadCandidates = (insightCtrl.positionData) && (insightCtrl.insightBlocks);
            if (needLoadCandidates) {
                await insightCtrl.getPotentialCandidates();
            }
            insightCtrl.summernoteOptions = {
                defaultFontName: 'Arial',
                toolbar: [
                    ['style', ['bold', 'italic', 'underline']],
                    ['alignment', ['ul']],
                    ['insert', ['ltr', 'rtl']],
                ],
                callbacks: {
                    onInit(summernote) {
                        summernote.toolbar.hide();
                        const $win = $(window); // or $box parent container
                        const $noteEditor = $('.note-editor');
                        $win.on('click.Bst', (event) => {
                            if ($noteEditor.has(event.target).length == 0 && !$noteEditor.is(event.target)) {
                                // click outside of summernote
                                summernote.toolbar.hide();
                            }
                        });
                        summernote.editable.focus(() => {
                            summernote.toolbar.show();
                        });
                    },
                },
            };
            insightCtrl.criteriaFields = RouteService.getSystemPreference('searchCriteriaFields');
            // position data
            if (insightCtrl.insightBlocks) {
                insightCtrl.areInsightGenerated = true;
                insightCtrl.updateCriteriaFields();
            }
            insightCtrl.activeCriteria = null;

            insightCtrl.printButtonIcon = {
                cssClass: 'printer-icon',
                src: 'assets/img/icons/build/svg-sprite.svg#printer',
            };
            insightCtrl.pdfButtonIcon = {
                cssClass: 'render-pdf-icon',
                src: 'assets/img/icons/build/svg-sprite.svg#new_pdf',
            };
            insightCtrl.copyButtonIcon = {
                cssClass: 'copy-link-icon',
                src: 'assets/img/icons/build/svg-sprite.svg#copy_icon',
            };
            insightCtrl.loading = false;
            insightCtrl.needToCloseModalDialog = false;
        };

        insightCtrl.updateCriteriaFields = function () {
            this.isRefreshInsightReportLabelVisible = this.getRefreshInsightReportLabelVisibilityState(this.positionData, this.insightBlocks);

            if (insightCtrl.criteriaFields) {
                const newCriteriaFields = angular.copy(insightCtrl.criteriaFields);
                for (const criteriaField of newCriteriaFields) {
                    const selectedProfile = insightCtrl.insightBlocks.desiredCandidateProfile.selected;
                    if (criteriaField.type === 'minMaxStatic') {
                        const minIndex = _.findIndex(selectedProfile, {field: criteriaField.minField});
                        const maxIndex = _.findIndex(selectedProfile, {field: criteriaField.maxField});
                        if (minIndex >= 0 || maxIndex >= 0) {
                            criteriaField.check = true;
                            if (minIndex >= 0) {
                                criteriaField.minSelected = selectedProfile[minIndex].items;
                            }
                            if (maxIndex >= 0) {
                                criteriaField.maxSelected = selectedProfile[maxIndex].items;
                            }
                        } else {
                            criteriaField.check = false;
                        }
                    } else {
                        const index = _.findIndex(selectedProfile, {field: criteriaField.field});
                        if (index >= 0) {
                            criteriaField.check = true;
                            criteriaField.selected = selectedProfile[index].items;
                        } else {
                            criteriaField.check = false;
                        }
                    }
                    if(!_.isNull(criteriaField.subCriteria)) {
                        dynamicDataService.addSubCriteriaData({ criteria: criteriaField });
                    }
                }

                insightCtrl.criteriaFields = newCriteriaFields;
            }
        };

        insightCtrl.generateInsights = function () {
            const anySelectedSearchCriteria = insightCtrl.positionData.desiredCandidateProfile.selected.length;

            if (anySelectedSearchCriteria) {
                insightCtrl.loading = true;

                return PositionReportService.createPositionReport(insightCtrl.positionId)
                    .then((insightsResponse) => {
                        insightCtrl.insightBlocks = insightsResponse.result;
                        insightCtrl.areInsightGenerated = true;
                        insightCtrl.getPotentialCandidates();
                        insightCtrl.updateCriteriaFields();
                        insightCtrl.onInsightDidUpdate(false);
                    })
                    .then(() => insightCtrl.loading = false)
                    .catch((err) => {
                        logger.error(err);
                        insightCtrl.insightBlocks = {};
                        insightCtrl.loading = false;
                    });
            }
            NotificationService.error('INSIGHT_GEN_ERROR_NO_SEARCH');
        };

        insightCtrl.openModalDialog = function (data) {
            insightCtrl.modalDialogData = angular.copy(data);

            if (insightCtrl.modalDialogData && insightCtrl.modalDialogData.otherCompanies) {
                insightCtrl.modalDialogData.otherCompanies = _.map(data.otherCompanies, 'companyName');
            }

            const modalInstance = this.$uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: `components/position/insight/modalDialogs/${insightCtrl.modalDialogView}`,
                controller: 'insightModalsCtrl',
                controllerAs: 'insightModalsCtrl',
                windowClass: 'insights',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    insightCtrl,
                }
            });

            modalInstance.result.then(() => {}, () => {});
        };

        insightCtrl.closeModalDialog = function (isCancel = true) {
            const msg = $filter('translate')('TALENYA_INSIGHTS_MODAL_CONFIRMATION_MESSAGE');
            if (((isCancel) && (window.confirm(msg))) || (!isCancel)) {
                insightCtrl.modalDialogData = null;
                insightCtrl.needToCloseModalDialog = true;
                insightCtrl.$uibModalInstance.close('Closed');
            }
        };

        insightCtrl.jobTitleChanged = function () {
            if (insightCtrl.JobTitleGetDataDelay) {
                $timeout.cancel(insightCtrl.JobTitleGetDataDelay);
                insightCtrl.openedPopup = false;
            }
            if (insightCtrl.modalDialogData.positionTitle && insightCtrl.modalDialogData.positionTitle.length > 1) {
                insightCtrl.JobTitleGetDataDelay = $timeout(() => {
                    const requestBody = {
                        currentField: {
                            field: 'jobTitles',
                            type: 'Text',
                            value: insightCtrl.modalDialogData.positionTitle,
                            matchType: 'contains',
                        },
                        searchCountries: [
                            {
                                code: 'IL',
                            },
                        ],
                        maxItems: insightCtrl.JobTitleValuesCount,
                        searchLanguages: [
                            {
                                code: 'en-US',
                            },
                        ],
                        selected: [],
                    };
                    dynamicDataService.getFilteredValues(requestBody)
                        .then((response) => {
                            insightCtrl.jobTitlefocusedOn = 0;
                            insightCtrl.openedPopup = true;
                            insightCtrl.jobTitleFilteredData = response.result;
                        })
                        .catch(err => logger.error(err));
                }, insightCtrl.JobTitleValuesDynamicDelay, false);
            }
        };

        insightCtrl.jobTitleCheckIfEnterKeyWasPressed = function (event) {
            const keyCode = event.which || event.keyCode;
            if (keyCode === 13) {
                if (insightCtrl.JobTitleGetDataDelay) {
                    $timeout.cancel(insightCtrl.JobTitleGetDataDelay);
                }
                insightCtrl.openedPopup = false;
                event.preventDefault(insightCtrl.modalDialogData);
            }
        };

        insightCtrl.editRequirements = function () {
            insightCtrl.insightBlocks.desiredCandidateProfile.selected =
                (insightCtrl.modalDialogData || []).reduce((criteria, criteriaItem) => {
                    if (criteriaItem.type === 'minMaxStatic') {
                        return [...criteria, {
                            field: criteriaItem.minField,
                            items: criteriaItem.minSelected,
                        }, {
                            field: criteriaItem.maxField,
                            items: criteriaItem.maxSelected,
                        }];
                    }

                    return [...criteria, {
                        field: criteriaItem.field,
                        items: criteriaItem.selected,
                    }];
                }, []);

            insightCtrl.onInsightWillUpdate();
            PositionReportService.updatePositionReport(insightCtrl.positionData._id, insightCtrl.insightBlocks._id, {
                updatePart: {
                    desiredCandidateProfile: insightCtrl.insightBlocks.desiredCandidateProfile,
                }
            })
                .then(() => insightCtrl.onInsightDidUpdate());
            insightCtrl.updateCriteriaFields();
            insightCtrl.closeModalDialog(false);
        };

        insightCtrl.initAddExpert = function () {
            // Get All Recruiters
            RecruiterService.getRecruiters()
                .then((recruiters) => {
                    insightCtrl.recruiters = recruiters.result;
                    for (let i = 0; i < insightCtrl.insightBlocks.recruiters.length; i++) {
                        const recruiter = insightCtrl.insightBlocks.recruiters[i];
                        const idx = _.findIndex(
                            insightCtrl.recruiters,
                            { fullName: recruiter.recruiterName },
                        );
                        if (idx > -1) {
                            insightCtrl.recruiters.splice(idx, 1);
                        }
                    }
                    insightCtrl.filteredTalentExperts = insightCtrl.recruiters;
                })
                .catch(err => logger.error(err));
        };

        insightCtrl.expertNameChanged = function () {
            if (!insightCtrl.teName || insightCtrl.teName === '') {
                insightCtrl.filteredTalentExperts = insightCtrl.recruiters;
                return;
            }
            const data = _.filter(insightCtrl.recruiters, recruiter => (recruiter.fullName.toLowerCase()
                .indexOf(insightCtrl.teName.toLowerCase()) >= 0));
            insightCtrl.filteredTalentExperts = data;
        };

        insightCtrl.addTalentExperts = function () {
            insightCtrl.teName = '';
            insightCtrl.expertNameChanged();
            const newRecuiters = _.filter(insightCtrl.recruiters, { selected: true });
            const teData = [];
            for (let j = 0; j < newRecuiters.length; j++) {
                const tempRecruiter = {
                    recruiterName: newRecuiters[j].fullName,
                    recruiterId: newRecuiters[j]._id,
                    recruiterImageUrl: newRecuiters[j].photoURL,
                    recruiterJobTitle: '',
                    recruiterFormerJobTitle: '',
                };
                teData.push(tempRecruiter);
            }
            const insightsRecruiters = insightCtrl.insightBlocks.recruiters.concat(teData);
            insightCtrl.onInsightWillUpdate();
            PositionReportService.updatePositionReport(insightCtrl.positionData._id, insightCtrl.insightBlocks._id, {
                updatePart: {
                    recruiters: insightsRecruiters,
                }
            })
                .then(() => insightCtrl.onInsightDidUpdate());
            insightCtrl.insightBlocks.recruiters = insightsRecruiters;
            insightCtrl.closeModalDialog(false);
        };

        insightCtrl.updateTalenyaInsights = function (data) {
            insightCtrl.onInsightWillUpdate();

            return PositionReportService.updatePositionReport(insightCtrl.positionData._id, insightCtrl.insightBlocks._id, {
                updatePart: {
                    talenyaInsights: data,
                }
            })
                .then(() => {
                    insightCtrl.insightBlocks.talenyaInsights = data;
                    insightCtrl.closeModalDialog(false);
                    insightCtrl.onInsightDidUpdate();
                });
        };

        insightCtrl.editJobInformation = function (data) {
            insightCtrl.onInsightWillUpdate();
            PositionReportService.updatePositionReport(insightCtrl.positionData._id, insightCtrl.insightBlocks._id, {
                updatePart: {
                    jobInformation: data,
                }
            })
                .then(() => insightCtrl.onInsightDidUpdate());
            insightCtrl.insightBlocks.jobInformation = data;
            insightCtrl.closeModalDialog(false);
        };

        insightCtrl.copyLinkToClipboard = function () {
            const prospectLink = `${EnvSettings.Auth0RedirectUrl}#/insightReport/${insightCtrl.positionId}`;
            clipboard.copyText(prospectLink);
            NotificationService.success('Copied');
        };

        insightCtrl.removeRecruiter = function (recruiter) {
            const idx = _.findIndex(insightCtrl.insightBlocks.recruiters, { recruiterId: recruiter.recruiterId });
            if (idx > -1) {
                insightCtrl.insightBlocks.recruiters.splice(idx, 1);
            }
            insightCtrl.onInsightWillUpdate();
            PositionReportService.updatePositionReport(insightCtrl.positionData._id, insightCtrl.insightBlocks._id, {
                updatePart: {
                    recruiters: insightCtrl.insightBlocks.recruiters,
                }
            })
                .then(() => insightCtrl.onInsightDidUpdate());
        };

        insightCtrl.editMarketAnalysis = function (data) {
            const marketAnalysisData = {};

            if (data.marketSalaryRange && (data.marketSalaryRange.minValue || data.marketSalaryRange.maxValue)) {
                marketAnalysisData.marketSalaryRange = {};
                // if market salary min value been edited then add it to the api request
                if (data.marketSalaryRange.minValue) {
                    marketAnalysisData.marketSalaryRange.minValue = data.marketSalaryRange.minValue;
                }
                // if market salary max value been edited then add it to the api request
                if (data.marketSalaryRange.maxValue) {
                    marketAnalysisData.marketSalaryRange.maxValue = data.marketSalaryRange.maxValue;
                }
            }

            if (data.employerSalaryRange && (data.employerSalaryRange.minValue || data.employerSalaryRange.maxValue)) {
                marketAnalysisData.employerSalaryRange = {};
                // if employer salary min value been edited then add it to the api request
                if (data.employerSalaryRange.minValue) {
                    marketAnalysisData.employerSalaryRange.minValue = data.employerSalaryRange.minValue;
                }
                // if employer salary max value been edited then add it to the api request
                if (data.employerSalaryRange.maxValue) {
                    marketAnalysisData.employerSalaryRange.maxValue = data.employerSalaryRange.maxValue;
                }
            }

            let companies = [];
            // if other companies been edited then add it to the api request
            if (data.otherCompanies && !Array.isArray(data.otherCompanies)) {
                companies = data.otherCompanies.split(',');
                marketAnalysisData.otherCompanies = [];
            } else {
                companies = data.otherCompanies;
                marketAnalysisData.otherCompanies = [];
            }
            for (let i = 0; i < companies.length; i++) {
                marketAnalysisData.otherCompanies.push({ companyName: companies[i] });
            }

            // if amountSimilarJobs been edited then add it to the api request
            if (data.amountSimilarJobs) {
                marketAnalysisData.amountSimilarJobs = data.amountSimilarJobs;
            }

            // if candidateToJobRatio been edited then add it to the api request
            if (data.candidateToJobRatio) {
                marketAnalysisData.candidateToJobRatio = data.candidateToJobRatio;
            }

            insightCtrl.onInsightWillUpdate();
            PositionReportService.updatePositionReport(insightCtrl.positionData._id, insightCtrl.insightBlocks._id, {
                updatePart: {
                    marketAnalysis: marketAnalysisData,
                }
            })
                .then(() => insightCtrl.onInsightDidUpdate());
            insightCtrl.insightBlocks.marketAnalysis = data;
            insightCtrl.insightBlocks.marketAnalysis.otherCompanies = marketAnalysisData.otherCompanies;
            insightCtrl.closeModalDialog(false);
        };

        insightCtrl.getNewCandidate = async function (idx) {
            // change candidate list to look like the insight potential candidate
            const { talentScoreData } = InsightComponent;
            const matchScore = talentScoreData[insightCtrl.currentCandidatesListIndex].matchScore;
            const temp = _.find(
                InsightComponent.candidatesList,
                { talentId: talentScoreData[insightCtrl.currentCandidatesListIndex].talentID },
            );
            if (!temp) {
                NotificationService.error('REPLACE_CANDIDATE_BLOCKED_MISSING_CANDIDATES');
                return;
            }
            const currentCandidate = {
                talentName: temp.name,
                talentId: temp.talentId,
                talentImageUrl: temp.photos[0],
                companyLocation: temp.location,
                predictionScore: temp.predictionScore,
                matchScore,
            };
            currentCandidate.companyLocation.locationName = '';
            const currentComp = _.find(temp.employmentHistory, (job) => {
                if (job.isCurrent) {
                    return job;
                }
            });
            if (currentComp) {
                currentCandidate.currentCompany = currentComp.employerOrgName;
                currentCandidate.jobTitle = '';
                for (let j = 0; j < currentComp.titles.length; j++) {
                    if (j !== currentComp.titles.length - 1) {
                        currentCandidate.jobTitle += `${currentComp.titles[j].title} &`;
                    } else {
                        currentCandidate.jobTitle += ` ${currentComp.titles[j].title}`;
                    }
                }
            }
            // replace the insight potential candidate #idx to the candidate list #currentIndexInList
            insightCtrl.insightBlocks.potentialCandidates[idx] = currentCandidate;
            insightCtrl.onInsightWillUpdate();
            PositionReportService.updatePositionReport(insightCtrl.positionData._id, insightCtrl.insightBlocks._id, {
                updatePart: {
                    potentialCandidates: insightCtrl.insightBlocks.potentialCandidates,
                }
            })
                .then(() => {
                    insightCtrl.currentCandidatesListIndex++;
                    insightCtrl.stopLoading();
                })
                .catch(err => logger.error(err));
        };

        insightCtrl.updateTalentExpertData = function (data) {
            insightCtrl.insightBlocks.recruiters[insightCtrl.editedTEIdx] = data;
            insightCtrl.onInsightWillUpdate();
            PositionReportService.updatePositionReport(insightCtrl.positionData._id, insightCtrl.insightBlocks._id, {
                updatePart: {
                    recruiters: insightCtrl.insightBlocks.recruiters,
                }
            })
                .then(() => insightCtrl.onInsightDidUpdate());
            insightCtrl.closeModalDialog(false);
        };

        insightCtrl.print = async () => {
            insightCtrl.loading = true;
            try{
                await InsightService.printReport($scope);
            } catch(err){
                logger.error(err);
            } finally {
                insightCtrl.loading = false;
                insightCtrl.$scope.$apply();
            }
        };

        insightCtrl.renderToPdf = () => {
            const fileNameOptions = {
                positionName: insightCtrl.positionData.jobTitle,
                companyName: insightCtrl.positionData.employerData.name,
            };
            insightCtrl.loading = true;

            InsightService
                .downloadPdfReport($scope, fileNameOptions)
                .then(() => insightCtrl.loading = false)
                .catch(err => logger.error(err));
        };

        insightCtrl.refreshInsights = () => {
            insightCtrl.insightsContainerDataLoading = true;

            PositionReportService.refreshTalenyaInsightsPart(insightCtrl.positionId, insightCtrl.insightBlocks._id)
                .then((insightsResponse) => {
                    insightCtrl.insightBlocks.talenyaInsights = insightsResponse.result.talenyaInsights;
                    insightCtrl.insightsContainerDataLoading = false;
                    insightCtrl.onInsightDidUpdate();
                })
                .catch((err) => {
                    insightCtrl.insightsContainerDataLoading = false;
                    logger.error(err);
                });
        };

        insightCtrl.refreshButtonIcon = {
            cssClass: 'union-icon-blue',
        };

        insightCtrl.editButtonIcon = {
            cssClass: 'edit-icon-blue',
        };

        insightCtrl.closeButtonIcon = {
            cssClass: 'x-icon-grey',
        };

        insightCtrl.openInsightReportPreviewPage = () => {
            const url = $state.href('insightReport', { positionId: insightCtrl.positionId });

            window.open(url, '_blank');
        };
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }

    $onChanges() {
        if (this.insightBlocks) {
            this.areInsightGenerated = true;
            this.updateCriteriaFields();
        }
    }

    onInsightWillUpdate() {
        this.startLoading();
    }

    onInsightDidUpdate(reload = true) {
        this.stopLoading();

        if (reload) {
            const { $state, $stateParams } = this;

            $state.current.data.selectedTab = INSIGHT_TAB;
            $state.go($state.current, $stateParams, { reload: true });
        }

        this.onInsightChange({ insightData: this.insightBlocks });
    }

    async refreshSearchCriteria() {
        this.searchCriteriaContainerDataLoading = true;

        try {
            const { result: { desiredCandidateProfile } } =
                await this.PositionReportService.refreshSearchCriteriaPart(this.positionId, this.insightBlocks._id);

            this.$timeout(() => {
                this.insightBlocks.desiredCandidateProfile = desiredCandidateProfile;
                this.updateCriteriaFields();
            });
        } catch (error) {
            logger.error(error);
        } finally {
            this.searchCriteriaContainerDataLoading = false;
        }
    }

    getRefreshInsightReportLabelVisibilityState(positionData, insightData) {
        const desiredCandidateProfileLastUpdate = _.get(positionData, 'desiredCandidateProfile.lastUpdate', null);
        const insightDataLastUpdate = _.get(insightData, 'lastUpdate', null);

        return new Date(desiredCandidateProfileLastUpdate) > new Date(insightDataLastUpdate);
    }

    onRefreshInsightReportButtonClick() {
        this.ModalDialogService.showDialog({
            modalDialogId: 'confirmClaimId',
            title: 'INSIGHT_REPORT_REFRESH_VALIDATION_HEADER',
            body: 'INSIGHT_REPORT_REFRESH_VALIDATION_MESSAGE',
            showCancelButton: true,
            showCloseButton: false,
            cancelButtonClass: 'primary-button',
            customZIndex: 2000,
            buttons: [{
                label: 'INSIGHT_REPORT_REFRESH_VALIDATION_YES',
                className: 'default-button',
                onClick: () => this.refreshPositionReport(),
            }],
        });
    }

    async refreshPositionReport() {
        this.onInsightWillUpdate();

        try {
            const { result: insightBlocks } = await this.PositionReportService.refreshPositionReport(this.positionData._id, this.insightBlocks._id);

            this.$timeout(() => {
                this.insightBlocks = insightBlocks;
                this.updateCriteriaFields();

                this.onInsightDidUpdate(false);
            });
        } catch (error) {
            logger.error(error);
        }
    }

    hasAdditionalText(item) {
        return item.additional && ![INCLUDED, EXCLUDED, CURRENTLY_NOT].includes(item.additional.value || item.additional.text);
    }

    getPriorityStyleConfig(item) {
        const priority = item.required;
        const itemAdditional = item.additional && (item.additional.value || item.additional.text);
        const isExcluded = itemAdditional && [EXCLUDED, CURRENTLY_NOT].includes(itemAdditional);
        return this.tftTagsService.getTagStyles({ priority, isExcluded });
    }

    getPriorityClass(item) {
        const { className } = this.getPriorityStyleConfig(item);

        return className;
    }

    getPriorityStyles(item) {
        const { styles } = this.getPriorityStyleConfig(item);

        return styles;
    }
}

export const InsightComponentConfiguration = {
    template,
    bindings: {
        positionId: '=',
        criteria: '=',
        insightBlocks: '<',
        positionData: '=',
        onInsightChange: '&',
    },
    controller: InsightComponent,
    controllerAs: 'insightCtrl',
};

angular
    .module('TALENYA-FE')
    .component('insightComponent', InsightComponentConfiguration);
